import React, { Component } from "react";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./DraftEditor.css";

/**
 * Reusable Draft.js WYSIWYG Editor Component
 *
 * Props:
 *   - content (string)       : HTML string to display in the editor
 *   - onChange (function)     : Callback fired with the HTML string on every change
 *   - placeholder (string)   : Optional placeholder text
 *   - toolbarOptions (object) : Optional toolbar config override for react-draft-wysiwyg
 *   - wrapperClassName (string)
 *   - toolbarClassName (string)
 *   - editorClassName (string)
 */

class DraftEditor extends Component {
  constructor(props) {
    super(props);
    this._internalChange = false;
    this.state = {
      editorState: EditorState.createEmpty(),
    };
  }

  componentDidMount() {
    if (this.props.content) {
      this.setEditorContent(this.props.content);
    }
  }

  componentDidUpdate(prevProps) {
    // Skip re-setting editor content when the change came from typing
    if (prevProps.content !== this.props.content) {
      if (this._internalChange) {
        this._internalChange = false;
        return;
      }
      if (!this.props.content) {
        this.setState({ editorState: EditorState.createEmpty() });
      } else {
        this.setEditorContent(this.props.content);
      }
    }
  }

  setEditorContent(html) {
    if (!html) {
      this.setState({ editorState: EditorState.createEmpty() });
      return;
    }
    const blocksFromHtml = htmlToDraft(html);
    if (blocksFromHtml) {
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap,
      );
      const editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState });
    }
  }

  onEditorStateChange = (editorState) => {
    this._internalChange = true;
    this.setState({ editorState });
    if (this.props.onChange) {
      const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      this.props.onChange(html);
    }
  };

  render() {
    const { editorState } = this.state;
    const {
      placeholder,
      toolbarOptions,
      wrapperClassName,
      toolbarClassName,
      editorClassName,
    } = this.props;

    const defaultToolbar = {
      options: ["inline", "list", "link"],
      inline: {
        options: ["bold", "italic", "underline"],
      },
      link: {
        options: ["link", "unlink"],
      },
    };

    return (
      <Editor
        editorState={editorState}
        onEditorStateChange={this.onEditorStateChange}
        wrapperClassName={wrapperClassName || "draft-editor-wrapper"}
        toolbarClassName={toolbarClassName || "draft-editor-toolbar"}
        editorClassName={editorClassName || "draft-editor-content"}
        toolbar={toolbarOptions || defaultToolbar}
        placeholder={placeholder || "Type here..."}
      />
    );
  }
}

export default DraftEditor;



// WEBPACK FOOTER //
// ./src/components/common/DraftEditor.js